export const selectElementContents = (element: HTMLElement | null) => {
	if (!element || typeof document === 'undefined') {
		return false
	}

	const selection = document.getSelection()
	if (!selection) {
		return false
	}

	const range = document.createRange()
	range.selectNodeContents(element)
	selection.removeAllRanges()
	selection.addRange(range)

	return true
}
